// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"88a96a20","588":"f61d99c5","851":"6bae0fc5","877":"bf4bd98a","882":"9a5ba81d","942":"0ab93464","993":"786fabb0"}[chunkId] + ".chunk.js";
};